import { PostProperties } from "../types";
import image from "../img/exposeDvorjack.jpg";

const post: PostProperties = {
  id: 46,
  title: "Exposé 13 - Dvorjack",
  content:
    "Derived from Antonín Dvořák’s name, Dvorjack’s eclectic style blends diverse elements of electronic music into a sound that creates a world of its own. Much like Dvořák, Dvorjack draws inspiration from the past while reinterpreting familiar sounds and influences to create something new and original.",
  image,
  buttonText: "Read More",
  buttonUrl: "expose-13-dvorjack",
  category: "Expose",
  embedCode: `<iframe width="100%" height="600" scrolling="no" frameborder="no" allow="autoplay; encrypted-media" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%3Atracks%3A2418857976%3Fsecret_token%3Ds-KHkgv990izV&color=%23f696a4&auto_play=true&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/shubinproject" title="Shubin" target="_blank" style="color: #cccccc; text-decoration: none;">Shubin</a> · <a href="https://soundcloud.com/shubinproject/expose-dvorjack/s-KHkgv990izV" title="Exposé 13 - Dvorjack" target="_blank" style="color: #cccccc; text-decoration: none;">Exposé 13 - Dvorjack</a></div>`,
  questionsAndAnswers: [
    {
      question: "Who is Dvorjack? Is there any significance behind the name?",
      answer:
        "Dvorjack is my artist pseudonym and a tribute to Eastern European artistic contribution. It's derived from Antonin Dvorak's surname, a 19th-century classical composer who pioneered the fusion of Slavic folk music and Western classical. It's paying respect to tradition, twisted through the present into something new. Or so I hope.",
    },
    {
      question: "How did your journey into electronic music start?",
      answer:
        "I was lucky enough to meet the right people who showed me the right tracks and took me to the right parties. I understood the spirit of underground electronica better and found a new passion for it. Never looked back.",
    },
    {
      question: "What is a recent piece of art that inspired you?",
      answer: "Brave New World by Aldous Huxley, Inferno by Boards of Canada",
    },
    {
      question:
        "How would you describe your sound to someone who has never heard you mix before?",
      answer:
        "In simplest terms—a box of chocolates. I like weird sounds and sonic atmospheres. I do my best to deliver them to anyone willing to listen. This one's a bit more of an ode to my starting days in techno and electro.",
    },
    {
      question: "Are you currently working on any productions?",
      answer:
        "Yes, always am. Still honing the skills that can bring out my sound more confidently, but I'm very eager to start putting more stuff out in the ether.",
    },
    {
      question: "Has your local scene influenced you?",
      answer:
        "Big time. I've spent the last 10 years in Groningen, and it has provided a lot of memorable experiences within the underground electronic music scene. The variety of electronica has stagnated as of late, though, and the more successful organisations seem to have commodified themselves and have started following social trends, which, in my opinion, has hurt the spirit of raving locally. Authenticity has taken a backstage, and the people can feel it, in my opinion. I know I can. Nevertheless, I've come to know some pretty promising and interesting individuals and artists in recent years, and new communities pop up more and more often with fresh perspectives on what the scene should look like and how to get there.",
    },
    {
      question:
        "Can you pinpoint a specific party or a moment which has completely changed the way you listen to music?",
      answer:
        "I heard DJ Rush at BASIS a few years back, and it's a party that has stayed with me since. What really stood out was how raw Rush's music and style are. The energy he was giving back to the crowd was wild and primal. 10/10.",
    },
    {
      question: "What is the idea behind the mix?",
      answer:
        "The idea is to put music out there that I like to listen to, and I think this mix is a pretty good reflection of the sounds I'd like to hear more when I'm on the dance floor as well, not just behind the decks.",
    },
    {
      question: "Favourite producer(s)?",
      answer: "Pom Pom, Froyd, Sterac, Fjaak, DJ Hörde, Bjarki, Karenn, KiNK",
    },
    {
      question: "Favourite DJ(s)?",
      answer: "DVS1, DJ Rush, KiNK, Fjaak, Chlär",
    },
    {
      question: "Favourite DJ mix?",
      answer:
        "Current: Mitsubasa Podcast Series 001: Benales. One that stayed: Irini - lost in dreams",
    },
  ],
  translationsBg: {
    content:
      "Произхождащ от името на Антонин Дворжак, еклектичният стил на Dvorjack съчетава разнообразни елементи на електронната музика в звук, който създава свой собствен свят. Подобно на Дворжак, Dvorjack черпи вдъхновение от миналото, преосмисляйки познати звуци и влияния, за да създаде нещо ново и оригинално.",
    questionsAndAnswers: [
      {
        question: "Кой е Dvorjack? Има ли особено значение зад името?",
        answer:
          "Dvorjack е моят артистичен псевдоним и почит към източноевропейския принос в изкуството. Произлиза от фамилията на Антонин Дворжак, класически композитор от 19-ти век, който пионерски съчетава славянски народен фолклор със западната класическа музика. Това е израз на почит към традицията, преплетена през настоящето в нещо ново. Поне така се надявам.",
      },
      {
        question: "Как започна твоето пътуване в електронната музика?",
        answer:
          "Имах късмета да срещна правилните хора, които ми показаха правилните песни и ме отведоха на правилните партита. Разбрах по-добре духа на underground електрониката и открих нова страст към нея. Никога не съм поглеждал назад.",
      },
      {
        question:
          "Кое е последното произведение на изкуството, което те е вдъхновило?",
        answer: "Brave New World на Aldous Huxley, Inferno на Boards of Canada",
      },
      {
        question:
          "Как би описал звука си на някой, който никога не те е чувал да миксираш?",
        answer:
          "В най-прости думи – кутия шоколадови бонбони. Харесвам странни звуци и звукови атмосфери. Правя всичко възможно да ги предам на всеки, който е готов да слуша. Този микс е по-скоро ода към началните ми дни в техното и електрото.",
      },
      {
        question: "Работиш ли в момента по някакви продукции?",
        answer:
          "Да, винаги работя. Все още усъвършенствам уменията, които могат да извадят звука ми по-уверено, но съм много нетърпелив да започна да пускам повече материал в етера.",
      },
      {
        question: "Повлия ли ти местната сцена?",
        answer:
          "Силно. Прекарал съм последните 10 години в Groningen, и той ми е предоставил много запомнящи се преживявания в underground електронната музикална сцена. Разнообразието на електрониката обаче застоя напоследък, а по-успешните организации изглежда са се комерсиализирали и са започнали да следват социални тенденции, което според мен е навредило на духа на локалните партита. Автентичността е отишла на заден план, и хората го усещат, според мен. Знам, че аз го усещам. Въпреки това, през последните години опознах доста обещаващи и интересни личности и артисти, и все по-често се появяват нови общности със свежи перспективи за това как трябва да изглежда сцената и как да се стигне до там.",
      },
      {
        question:
          "Можеш ли да посочиш конкретно парти или момент, който напълно е променил начина, по който слушаш музика?",
        answer:
          "Чух DJ Rush в BASIS преди няколко години, и това е парти, което остана с мен оттогава. Това, което наистина се откроява, е колко суров е стилът и музиката на Rush. Енергията, която връщаше на публиката, беше дива и първична. 10/10.",
      },
      {
        question: "Каква е идеята зад микса?",
        answer:
          "Идеята е да пусна музика, която обичам да слушам, и мисля, че този микс е доста добро отражение на звуците, които бих искал да слушам повече, когато съм на дансинга, а не само зад пулта.",
      },
      {
        question: "Любим(и) продуцент(и)?",
        answer: "Pom Pom, Froyd, Sterac, Fjaak, DJ Hörde, Bjarki, Karenn, KiNK",
      },
      {
        question: "Любим(и) DJ?",
        answer: "DVS1, DJ Rush, KiNK, Fjaak, Chlär",
      },
      {
        question: "Любим DJ микс?",
        answer:
          "Настоящ: Mitsubasa Podcast Series 001: Benales. Този, който остана: Irini - lost in dreams",
      },
    ],
  },
};

export default post;
